import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["highlighted", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React from 'react';
import { Grid as ChakraGrid } from '@chakra-ui/react';
export function Grid(props) {
  var highlighted = props.highlighted,
    style = props.style,
    rest = _objectWithoutProperties(props, _excluded);

  // Applied as component style until we have a solution for chemistry styling
  var highlightedStyle = _objectSpread({
    backgroundColor: '#eeede9',
    borderRadius: '8px',
    padding: '8px 8px 16px 8px'
  }, style);
  return /*#__PURE__*/React.createElement(ChakraGrid, _extends({
    style: highlighted ? highlightedStyle : style
  }, rest), props.children);
}